import { writable } from 'svelte/store';

// export const user = writable({});

const storage_permissions = localStorage.getItem("permissions");

export const permissions = writable(storage_permissions ? JSON.parse(storage_permissions) : []); // storage_user ? JSON.parse(storage_user) : {}

permissions.subscribe(value => {
    localStorage.setItem("permissions", JSON.stringify(value));
});